export const AUTH_TOKEN = 'tfc_id_token'
